import React, { useState } from "react";
import {
  SpaceBetween,
  Button,
  Container,
  Header,
  Form,
  FormField,
  Input,
  Alert,
} from "@cloudscape-design/components";
import { useApi } from "../Api";

// Create Stake pre-prod account page.
// Mirrors the Tomahawk Debug Menu Create Account flow: the form posts to the
// portal backend, which holds the SPC keypair and calls the Stake Platform
// Connector. The keypair never reaches the browser.
export default function StakeAccount() {
  const Api = useApi();
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  const canSubmit = email.trim().length > 0 && password.length > 0 && !submitting;

  const submit = async () => {
    setSubmitting(true);
    setResult(null);
    try {
      // Backend returns 200 with { success, message, ... } for both outcomes,
      // because the shared Api helper throws away the body on non-2xx.
      const res = await Api.post("StakeAccount/", {
        email: email.trim(),
        username: username.trim(),
        password,
      });
      setResult(res);
    } catch (err) {
      setResult({ success: false, message: "Request failed. Please try again." });
    }
    setSubmitting(false);
  };

  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Create a Stake pre-production account for testing (steak-kitchen-casino.com)."
        >
          Create Stake Account
        </Header>
      }
    >
      <SpaceBetween size="l">
        <Alert type="info">
          Pre-production only. Use a plus-addressed email (for example
          you+stake@welldoneentertainment.com) if you need more than one account.
        </Alert>

        <Form
          actions={
            <Button
              variant="primary"
              loading={submitting}
              disabled={!canSubmit}
              onClick={submit}
            >
              Create Account
            </Button>
          }
        >
          <SpaceBetween size="m">
            <FormField label="Email">
              <Input
                type="email"
                value={email}
                onChange={({ detail }) => setEmail(detail.value)}
                placeholder="you@welldoneentertainment.com"
                disabled={submitting}
              />
            </FormField>
            <FormField label="Username">
              <Input
                value={username}
                onChange={({ detail }) => setUsername(detail.value)}
                placeholder="username"
                disabled={submitting}
              />
            </FormField>
            <FormField label="Password">
              <Input
                type="password"
                value={password}
                onChange={({ detail }) => setPassword(detail.value)}
                disabled={submitting}
              />
            </FormField>
          </SpaceBetween>
        </Form>

        {result &&
          (result.success ? (
            <Alert type="success" header="Account created">
              {result.stub ? "Stub response (SPC not wired yet). " : ""}
              Email: {result.email}
              {result.username ? ` -- Username: ${result.username}` : ""}
            </Alert>
          ) : (
            <Alert type="error" header="Could not create account">
              {result.message || "Unknown error"}
            </Alert>
          ))}
      </SpaceBetween>
    </Container>
  );
}
